import { RowAlignedItems } from '@components/LinearLayout';
import styled from 'styled-components';

export const Header = styled(RowAlignedItems)`
  justify-content: space-between;
`;
